import React from 'react';

const BookingdetailsContext = React.createContext({});

export { BookingdetailsContext };